//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IContentLibraryItem } from '@apis/content-library/contentLibraryApiModel';
import { RIGHTS_OWNED_OR_PENDING_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { getBulkActionsActions } from '@react-bridge/wrappers/ng-service-provider';
import { createAction } from '@utils/actions';
import { ReduxDispatch } from 'app/curalate.store';

const openModal = (
  rightsOwnedItems: IContentLibraryItem[],
  numTotalItems: number,
) => {
  return createAction({
    type: RIGHTS_OWNED_OR_PENDING_MODAL_ACTIONS.OPEN_MODAL,
    rightsOwnedItems,
    numTotalItems,
  });
};

const closeModal = () => {
  return createAction({
    type: RIGHTS_OWNED_OR_PENDING_MODAL_ACTIONS.CLOSE_MODAL,
  });
};

export type RightsOwnedOrPendingModalAction = ReturnType<
  typeof openModal | typeof closeModal
>;

export const rightsOwnedOrPendingModalActions = {
  openModal,

  closeModal: () => (dispatch: ReduxDispatch) => {
    const bulkActionsActions = getBulkActionsActions();
    dispatch(bulkActionsActions.clearSelectedItems());
    dispatch(closeModal());
  },
};
